// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: '09c79d6e-a081-45d4-9da1-c60d4acdcb48',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '1852cf1b-362b-4f3f-b8a5-17f51d15b0e5',
      type: 'Sprite',
      name: 'wonRewardIcon',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hammer_Booster',
      parent: '09c79d6e-a081-45d4-9da1-c60d4acdcb48',
      data: {
        maxSize: 200
      }
    },
    {
      id: '3355f104-6988-4eec-b999-292134eeeb4e',
      type: 'Text',
      name: 'wonRewardAmountText',
      className: '',
      x: 0,
      y: 88,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'xX',
      localize: false,
      maxWidth: 211,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 90,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '09c79d6e-a081-45d4-9da1-c60d4acdcb48'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  handleResize: false
} as const;

export class LuckyWheelRewardItemLayout {
  static raw = raw;
  root!: Container;
  wonRewardIcon!: Sprite & { data: typeof raw['list'][1]['data'] };
  wonRewardAmountText!: Text;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
